import { api } from './api';

export interface Precursor {
    id: number;
    name: string;
    group: string;
}

export const getPrecursors = async (): Promise<Precursor[]> => {
    const response = await api.get('/api/precursors/');
    return response.data;
};

export const createPrecursor = async (precursor: Omit<Precursor, 'id'>): Promise<Precursor> => {
    const response = await api.post('/api/precursors/', precursor);
    return response.data;
};

export const uploadPrecursors = async (file: File): Promise<Precursor[]> => {
    const formData = new FormData();
    formData.append('file', file);
    const response = await api.post('/api/precursors/upload', formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
    return response.data;
}; 